<template>
  <div id="stepsModal" ref="stepsModal" class="modal steps-modal">
    <div class="modal-header">
      <div class="nav-wrapper">
        <nav class="presentationNav indigo accent-2">
          <ul class="left labels-nav">
            <li>Slides {{stepInput}} / {{dataSteps.length}}</li>
          </ul>
          <ul class="menu-items right">
            <li><a @click="$_fullScreenMode()" class="full-screen waves-effect waves-block"><i class="material-icons white-text">fullscreen</i></a></li>
            <li><a  class="close-button modal-close"><i class="material-icons white-text waves-effect waves-block">close</i></a></li>
          </ul>
        </nav>
      </div>
      <div class="clear"></div>
    </div>
    <div class="modal-content">
      <div class="step-count" v-html="activeStep.tag_id"></div>
      <div class="step-title" v-html="activeStep.title">       
      </div>
      <div class="steps-content col " 
        v-bind:class="[activeStep.media ? 's12 l5 m5': 's12 l8 ']"
        v-html="activeStep.content">
      </div>
        <div class="media-player col s12 l7 m7" v-if="activeStep.media">
          <div v-bind:class="[item.subtype === 'gif' ? 'bind-image' : '']" class="col s12 no-padding " v-for="item in activeStep.media" v-bind:key="item.id">
             <img  :data-caption="activeStep.title"  class="left materialboxed"  v-expandable="item" 
              :src="item.url" alt=""  
              v-if="item.type === 'image' && item.subtype ==='gif' ||
              item.type === 'image' && item.subtype ==='png' ||  
              item.type === 'image' && item.subtype ==='jpeg'"  width="100%">
               <video controls="" id="player"  v-if="item.mime_type == 'video/mp4'" :src="item.url"></video>
          </div>
        </div>
    </div>
    <div class="slide-nav">
      <div class="col s4">
        <button @click="$_moveSlide('down')" class="btn-floating white  waves-effect"><i class="material-icons grey-text text-darken-3">arrow_back</i></button>
      </div>
      <div class="col s4">
        <input type="number" min="1" class="center-align" :max="dataSteps.length" v-model="stepInput">
      </div>
      <div class="col s4">
        <button @click="$_moveSlide('up')" class="btn-floating white  waves-effect"><i class="material-icons grey-text text-darken-3">arrow_forward</i></button>
      </div>
    </div>
  </div>
</template>
<script>
import appComponent from '@/cFunctions'
export default {
  name:'stepsPlayer',
  props:{
    dataSteps:{
      type:Array,
    },
    modalStatus:{
      type:String,
      default:'closed'
    }
  },
  data(){
    let vm = this
   return {
    currentStepIndex:0,
    modalInstance:'',
    modalOptions:{
      preventScrolling:false,
      dismissible:false,
      onOpenStart:()=>{
        vm.$route.query.startIndex || vm.$route.query.startIndex === 0
        ? vm.currentStepIndex = vm.$route.query.startIndex
        : ''
      },
      onOpenEnd:()=>{
         document.addEventListener('keydown', vm.$_keyBoardNavigation);
      },
      onCloseEnd:()=>{
        document.removeEventListener('keydown', vm.$_keyBoardNavigation)
        vm.$emit('status','closed')
      }
    }
   }
  },
  mounted(){

    this.$_initializeModalEL()
  },
  beforeDestroy(){
    try{
      this.modalInstance.destroy()
       document.removeEventListener('keydown', this.$_keyBoardNavigation)
    }
    catch(err){

    }
  },
  watch:{
    modalStatus:function (nV) {
      nV && nV === 'open' || nV && nV === 'opened'
      ? this.modalInstance.open()
      : this.modalInstance.close()
    },
    '$route':function(nV){
      console.log(nV)
      nV && nV.query.startIndex || nV.query.startIndex === 0 
      ? ''
      : this.modalInstance.close()
    }
  },
  computed:{
    stepInput:{
      get(){
        return this.currentStepIndex + 1
      },
      set($event){
        this.currentStepIndex + 1 <= this.dataSteps.length 
        ? this.currentStepIndex = $event - 1
        : this.currentStepIndex = this.dataSteps.length - 1
      }
    },
    activeStep:{
      get(){
        return this.dataSteps[this.currentStepIndex]
      }
    }
  },
  methods:{
    $_moveSlide(direction){
      direction === 'up' 
      ? this.currentStepIndex++
      : this.currentStepIndex = this.currentStepIndex - 1
    },
    $_fullScreenMode(){    
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
          if (document.exitFullscreen) {
            document.exitFullscreen(); 
          }
        }
    },
    $_keyBoardNavigation(e){
        console.log(e)
        if(e.code === 'ArrowRight' || e.code === 'Enter' && this.dataSteps.length > (this.currentStepIndex + 1))  this.currentStepIndex++
        if(e.code === 'KeyN' && this.dataSteps.length > (this.currentStepIndex + 1))  this.currentStepIndex++
        if(e.code === 'ArrowLeft' && this.currentStepIndex > 0 )  this.currentStepIndex = this.currentStepIndex - 1
        if(e.code === 'KeyP'  || e.code === 'Space' && this.currentStepIndex > 0 )  this.currentStepIndex = this.currentStepIndex - 1
    },
    $_initializeModalEL(){
      this.modalInstance = appComponent.initModal(this.$refs.stepsModal, this.modalOptions)
      this.$nextTick(()=>{
       this.modalStatus === 'open' ? this.modalInstance.open() : false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
#stepsModal {
  &.modal {
    min-width: 95%;
    min-height: 97%;
    top: 1% !important;
    @media screen and (min-width: 1024px) {
    min-width: 90%;
    min-height: 90%;
    top: 5% !important;
    }
    nav {
      padding-left:16px;
      height:48px;
      box-shadow: none !important;
      .labels-nav {
        font-size: 17px;
        letter-spacing: 1px;
        text-transform: uppercase;
        font-weight: 500
      }
      li, i {
        line-height: 48px; height:48px;
      }
    }
    .slide-nav {
      position: absolute;
      bottom:24px; right:24px;
    }
    .modal-content {
      height: calc(100% - 56px);
      overflow: hidden;
      overflow-y: scroll;
      position: absolute;
      left:0; right:0; bottom:0;
      .step-count {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background: rgba(238, 238, 238, 0.8);
        text-align: center;
        line-height: 50px;
        font-weight: 600;
        font-size: 18px;
        display: inline-block;
      }
      .step-title {
        font-size: 18px;
        width: calc(100% - 56px);
        line-height: 24px;
        padding: 0 0 0 8px;
        transform: translateY(-8px);
        display: inline-flex;       
          @media screen and (min-width:1024px){
            transform: translateY(0px);
            font-size: 28px;
            min-width: 90%;
          }
      }
    .steps-content {
      padding:0px 16px 0 16px;
   
    
      @media screen and (min-width:1024px){
       padding:0px 16px 0 66px;
      }
     
      p {
        font-size:16px;
        line-height:17.5px;
      }
    }
    .media-player {
      padding: 16px;
      background: #ececec;
      border-radius: 4px;
      .bind-image {
        max-height: 400px;
        overflow: hidden;
      }
      video {
        width:100%;
      }
    }
    }
  }
}
</style>
<style lang="scss">
    .steps-content {
      p {
        font-size:16px;
        line-height:20.5px;
        @media screen and (min-width:1024px){
            font-size: 18px;
            line-height: 26.5px;
            font-weight: 300;
        }
      }
      ol {
       li {
          font-size: 18px;
          font-weight: 300;
          line-height: 1.6;
       }
      }
      ul {
        padding-left: 24px !important;
        li {
          list-style: disc;
          list-style-type: disc;
          font-size: 18px;
          font-weight: 300;
          line-height: 1.6;
        }
      }
    }
.materialbox-caption {
    display: inline;
    opacity: 1;
    background: #536dfe !important;
    z-index: 99999;
}
</style>